import Alpine from "alpinejs";

const SVG_NS = 'http://www.w3.org/2000/svg';
const XHTML_NS = 'http://www.w3.org/1999/xhtml';

function normalizeAudioSrc(src: string): string {
    return src.startsWith('/') ? src : `/${src}`;
}

function getGroupBounds(el: Element): { x: number; y: number; width: number; height: number } {
    const rect = el.querySelector('rect');
    if (rect) {
        return {
            x: parseFloat(rect.getAttribute('x') || '0'),
            y: parseFloat(rect.getAttribute('y') || '0'),
            width: parseFloat(rect.getAttribute('width') || '0'),
            height: parseFloat(rect.getAttribute('height') || '0'),
        };
    }

    const bbox = (el as SVGGElement).getBBox();
    return {
        x: bbox.x,
        y: bbox.y,
        width: bbox.width,
        height: bbox.height,
    };
}

Alpine.data('audio', (src: string) => ({
    audioEl: null as HTMLAudioElement | null,

    init() {
        const bounds = getGroupBounds(this.$el);
        const foreignObject = document.createElementNS(SVG_NS, 'foreignObject');
        foreignObject.setAttribute('x', String(bounds.x));
        foreignObject.setAttribute('y', String(bounds.y));
        foreignObject.setAttribute('width', String(bounds.width));
        foreignObject.setAttribute('height', String(bounds.height));

        const wrapper = document.createElementNS(XHTML_NS, 'div');
        wrapper.setAttribute('xmlns', XHTML_NS);
        wrapper.className = 'audio-card';

        const audio = document.createElement('audio');
        audio.controls = true;
        audio.preload = 'metadata';
        audio.src = normalizeAudioSrc(src);

        wrapper.appendChild(audio);
        foreignObject.appendChild(wrapper);
        this.$el.appendChild(foreignObject);
        this.audioEl = audio;
    },
}));